import React from "react";

import {
  ResponsiveContainer,
  PieChart,
  Tooltip,
  Legend,
  Pie,
  Cell,
} from "recharts";

import { Typography } from "clearsense-ui/components";

const Chart = ({ title, data }) => (
  <div className="flex flex-col col-span-1 bg-white dark:bg-gray-800 border-2 h-96">
    <Typography
      style="h4"
      type="semibold"
      className="flex-none px-6 py-4 border-b-2"
    >
      {title}
    </Typography>
    <div className="flex-1 p-4 pb-0">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart width={450} height={350}>
          <Tooltip formatter={value => `${value}%`} />
          <Legend verticalAlign="top" align="center" />
          <Pie dataKey="value" data={data} innerRadius={40} outerRadius={80}>
            {data?.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.cellProps.fill} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  </div>
);

export default Chart;
